// src/shared/clock/useClock.js
import { useSyncExternalStore } from "react";

let now = Date.now();
const listeners = new Set();

function tick() {
  now = Date.now();
  for (const l of listeners) l();
}

// --- Start one interval per module instance ---
let intervalId = setInterval(tick, 1000);
// Ensure first paint is correct (no 1s wait)
tick();

// --- HMR cleanup (Vite + Webpack) ---
/* Vite */
if (typeof import.meta !== "undefined" && import.meta && import.meta.hot) {
  import.meta.hot.dispose(() => {
    if (intervalId) clearInterval(intervalId);
    intervalId = null;
  });
}
/* Webpack */
if (typeof module !== "undefined" && module && module.hot) {
  module.hot.dispose(() => {
    if (intervalId) clearInterval(intervalId);
    intervalId = null;
  });
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
function getSnapshot() {
  return now;
}
function getServerSnapshot() {
  return now;
}

export function useClock() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
